import React from 'react';
import RouteApp from "./routes/RouteApp";
import UserState from "./context/user/userState";
import InterfaceState from "./context/interface/interfaceState";

const App = () =>  {

    return (
        <UserState>
            <InterfaceState>
                <RouteApp />
            </InterfaceState>
        </UserState>

    );
}

export default App;
